import moment from "moment";
import Constants from "../Constants";

export const getCountryCode = (code) => {
  let REG = /^[a-z]{2,}(?:-[A-Z][a-z]*)*-([A-Z]{2})$/;
  var match = code.match(REG);
  if (!match) return "";
  return match[1];
};

function formatWithPlaceholders() {
  let str = "";
  if (arguments.length > 0) {
    str = arguments[0];
    for (let i = 1; i < arguments.length; i++) {
      str = str.replace(new RegExp(`{%${i}%}`, "g"), arguments[i].toString());
    }
  }
  return str;
}
const currentDateInApiFormat = () =>
  moment().utc().format(Constants.API_DATE_TIME_FORMAT);

const prepareCounterToast = (desc, counterNo = 4) => {
  return desc.replace("{counterNo}", counterNo);
};
const getCounterNo = (pickup_store_location = "SO") => {
  const storeLocations = Constants[localStorage.countryCode].preferredStoreLocations;
  let location = storeLocations.find((sl) => sl.name === pickup_store_location);
  let counterNo = location?.counterNo ?? 4;
  return counterNo;
};

export {
  formatWithPlaceholders,
  currentDateInApiFormat,
  prepareCounterToast,
  getCounterNo,
};
